import { useEffect } from "react";
import { useSentryCookieContextSynchronization } from "./sentry-cookie-context.js";
import { type SentryTrackingData, syncSentryTrackingDataTags } from "./sentry-tracking-context.js";

export const useSentryContextSynchronization = (trackingData: SentryTrackingData): void => {
  useSentryCookieContextSynchronization();

  useEffect(() => {
    syncSentryTrackingDataTags(trackingData);
  }, [
    trackingData.locationInfo.city,
    trackingData.locationInfo.countryCode,
    trackingData.locationInfo.isp,
    trackingData.locationInfo.org,
    trackingData.partnerId,
  ]);
};
